import { useCappsUserManagementWebApiHandler_userManagementCompanyDetails } from '@zg-rentals/ts-capps-client-react-query';

export function useGetLandlordCompany({ enabled }: { enabled: boolean }) {
  return useCappsUserManagementWebApiHandler_userManagementCompanyDetails({ enabled });
}
